export default __webpack_public_path__ + "static/media/simTransfer-6.c925c040.png";